/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 11th 2022, 2:54:17 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { DocumentTemplateMany2OnePicker } from "service-builder/components/documents";
import { TaskTemplate } from "lib/schemas";

export const DocumentTaskSettings = () => {
  return (
    <DocumentTemplateMany2OnePicker<TaskTemplate> schema_field_key="document" label="Document Template for this task" />
  );
};
